var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagCro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(1982 3341)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_540",
    "data-name": "Ret\\xE2ngulo 540",
    width: 102.831,
    height: 59.988,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_CRO",
    transform: "translate(-1982 -3341)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_croacia",
    transform: "translate(1960.711 3341)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_529",
    "data-name": "Ret\\xE2ngulo 529",
    width: 102.831,
    height: 19.999,
    transform: "translate(0 19.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_530",
    "data-name": "Ret\\xE2ngulo 530",
    width: 102.831,
    height: 20.001,
    transform: "translate(0 39.987)",
    fill: "#1e2788"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_531",
    "data-name": "Ret\\xE2ngulo 531",
    width: 102.831,
    height: 19.989,
    transform: "translate(0 0)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_844",
    "data-name": "Grupo 844",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_843",
    "data-name": "Grupo 843",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8211",
    "data-name": "Caminho 8211",
    d: "M137.9,16.237a35.7,35.7,0,0,1,11.753-2.023,35.231,35.231,0,0,1,12.07,2.054l3-6.033-2.107-3.669s-3.758,1.543-3.782,1.543-2.65-2.883-2.65-2.883l-3.358,2.035-3.153-2.412-2.962,2.376-3.471-2.011-2.52,3.01L136.929,6.6,134.9,10.235Z",
    transform: "translate(-98.395 3.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8212",
    "data-name": "Caminho 8212",
    d: "M161.8,16.409l-.065-.024a35.305,35.305,0,0,0-11.964-2.059,35.869,35.869,0,0,0-11.818,2.023L134.854,10.3l2.03-3.717,3.9,1.586L143.2,5.187l3.579,1.987,2.866-2.364L152.9,7.217l3.272-2.035c1.114,1.125,2.657,2.813,2.736,2.883.036-.048,2.686-1.137,3.7-1.555l2.22,3.71Zm-24.871-9.7-1.915,3.6L138,16.229a33.459,33.459,0,0,1,11.688-2.071,35.787,35.787,0,0,1,12.039,2.03l2.95-5.967-2.1-3.578c-3.662,1.579-3.686,1.579-3.71,1.579a27.24,27.24,0,0,1-2.705-2.907L152.9,7.361l-3.255-2.419-2.854,2.376-3.567-2-2.412,2.986Z",
    transform: "translate(-98.425 3.436)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8213",
    "data-name": "Caminho 8213",
    d: "M147.836,13.664,149.559,7.6l3.668-1.49,1.927,3.249-2.775,5.679a24.256,24.256,0,0,0-4.543-1.377",
    transform: "translate(-89.153 4.367)",
    fill: "#3a7aa1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8214",
    "data-name": "Caminho 8214",
    d: "M152.39,15.075l-.024-.007a24.025,24.025,0,0,0-4.529-1.375l1.7-6.081L153.216,6.1l1.963,3.267Zm.814-8.947-3.645,1.5-1.7,6.045a22.935,22.935,0,0,1,4.505,1.347l2.77-5.655Z",
    transform: "translate(-89.152 4.357)",
    fill: "#4c73d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8215",
    "data-name": "Caminho 8215",
    d: "M142.438,13.715l-.574-6.273,2.919-2.321,3.041,2.316-.538,6.278a47.05,47.05,0,0,0-4.848,0",
    transform: "translate(-93.418 3.658)",
    fill: "#3a7aa1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8216",
    "data-name": "Caminho 8216",
    d: "M147.314,13.75H147.3a44.718,44.718,0,0,0-4.846,0l-.6-6.3,2.921-2.345,3.075,2.321ZM144.77,5.137l-2.885,2.321.586,6.261a37.744,37.744,0,0,1,4.8-.012l.545-6.266Z",
    transform: "translate(-93.429 3.649)",
    fill: "#4c73d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8217",
    "data-name": "Caminho 8217",
    d: "M137.866,15.039l-2.722-5.745,1.812-3.185,3.765,1.641,1.6,5.937a23.059,23.059,0,0,0-4.452,1.353",
    transform: "translate(-98.218 4.364)",
    fill: "#3a7aa1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8218",
    "data-name": "Caminho 8218",
    d: "M137.865,15.07l-2.736-5.775,1.814-3.189,3.8,1.634,1.61,5.942a26.606,26.606,0,0,0-4.476,1.377Zm-.9-8.935-1.79,3.171,2.7,5.71a24.03,24.03,0,0,1,4.44-1.359l-1.61-5.894Z",
    transform: "translate(-98.229 4.362)",
    fill: "#4c73d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8219",
    "data-name": "Caminho 8219",
    d: "M136.39,10.224a4.471,4.471,0,0,0,2.143-.2,3.059,3.059,0,0,0,1.377-1.233,1.55,1.55,0,0,1-.845,1.968,2.106,2.106,0,0,1-2.674-.538",
    transform: "translate(-97.328 6.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8220",
    "data-name": "Caminho 8220",
    d: "M138,11.011a1.9,1.9,0,0,1-1.627-.8c.274,0,.5.012.706.012a4.142,4.142,0,0,0,1.447-.24,2.941,2.941,0,0,0,1.323-1.149,2.589,2.589,0,0,1-1.311,1.191,4.692,4.692,0,0,1-2.143.2,2.236,2.236,0,0,0,2.664.5,1.539,1.539,0,0,0,.922-1.49,1.433,1.433,0,0,1-.905,1.514,2.21,2.21,0,0,1-1.077.264",
    transform: "translate(-97.338 6.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8221",
    "data-name": "Caminho 8221",
    d: "M144.237,7.322l-.168.041.012.3-.214.041-.132.264.077.072c.012.012-.065.2-.053.2l.053.072.048.161.144.024.029.187.216.022.2.144.012.089.221.007.156.048.545-.065.077-.1V8.668l.288-.005.036-.245h.142l-.022-.276.13.012L146,8.029l-.079-.113-.022-.168-.223-.216-.041-.293-.144-.065c0-.007-.012-.192-.012-.192l.156-.24-.012-.077-.144-.005-.125.082a1.08,1.08,0,0,0-.144.031v.065l.036.132h-.168l-.012-.2-.245-.118s-.233.154-.233.161l-.012.173-.108.029-.113-.166-.2-.072-.115-.007V6.9l.216.264Z",
    transform: "translate(-92.082 4.748)",
    fill: "#fbfc2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8222",
    "data-name": "Caminho 8222",
    d: "M144.836,9.061l-.408-.048-.012-.132-.19-.108-.192-.024-.072-.226-.089.024-.127-.377.079-.108-.108-.036.12-.324.245-.077-.053-.24.209-.089-.024-.12-.2-.228V6.733l.154.012.209.077.132.18.036-.18c0-.029,0-.029.252-.2l.305.127.029.238.079-.048-.043-.065c0-.125.012-.132.2-.156l.091-.077.18-.012h.041l.024.137-.18.264.024.168c0-.036.115.024.115.024l.082.322.216.2.132.425-.18.055.079.214-.2.055.024.2-.346.053.041.108-.077.137Zm-.132-.144.156.048.531-.06.031-.089-.007-.132.341-.055-.024-.2.2-.041-.065-.221.185-.043-.168-.156-.017-.19-.209-.2-.072-.31c-.144-.041-.144-.041-.144-.077L145.435,7l.18-.257-.12-.019-.091.084c-.024.012-.142.019-.166.031.077.137.077.137.077.149l-.221.048-.067-.252-.214-.072c.012.019-.144.115-.173.144v.185l-.151.031-.161-.18-.168-.053-.041.077.185.24-.012.19-.2.079.041.257-.245.084-.1.238c.084.067.084.072.043.2-.031.007-.031.014.024.1l.065.168.091-.012.077.226.18-.005.226.161.012.1Z",
    transform: "translate(-92.095 4.727)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8223",
    "data-name": "Caminho 8223",
    d: "M143.819,7.792l.245-.012.041.209.079.084.012.37.077.036.024-.154.175-.012.034.31-.034.048.01.041.228-.012.055-.077a.683.683,0,0,1,.118-.005l.048.082.031-.113.125-.048c0,.007.089.156.089.156l.163-.024-.1-.089-.048-.2.233-.125.077.149s.091.007.079,0l-.1-.173V7.888l.173-.228.233-.024v-.1l-.233-.209-.053-.3-.132-.065L145.441,7l-.156.007.156.221v.137l.053.036-.005.389a1.415,1.415,0,0,0-.168.024l-.012.209-.1.108-.055.192a.969.969,0,0,0-.1.13h-.185a.919.919,0,0,1-.113-.106l-.012-.144-.079-.024a.86.86,0,0,1-.041-.168l-.139-.065v-.1l-.118-.048-.012-.089a.572.572,0,0,0-.067-.043V7.427l.1-.017-.06-.072-.019-.067V7.194l.091-.077-.168-.026-.144.067-.012.293-.18.041-.154.24Z",
    transform: "translate(-92.077 4.972)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8224",
    "data-name": "Caminho 8224",
    d: "M144.463,8.773l-.024-.084V8.331l-.132.046.019.108v.067l-.144-.055-.031-.418-.13-.281-.2.053-.089-.077.137-.3.2-.077c-.024-.012-.024-.209-.024-.233a.589.589,0,0,1,.18-.108.986.986,0,0,1,.2.005l-.082.259-.072-.043.072-.132a.193.193,0,0,1-.084,0c.029.019-.06.043-.115.055a1.593,1.593,0,0,1,0,.257l-.221.1-.113.214.257-.024.1.247.1.459-.012-.118.228-.06.094.353-.036.041.223-.024v.1Zm.736-.017c-.149-.18-.149-.192-.149-.211l-.077.048.012.031-.024-.079c.113-.048.125-.048.137-.048a1.089,1.089,0,0,1,.132.18l.113-.048-.125-.005-.055-.235.012-.012a.012.012,0,0,1-.012.012l-.065.1-.221.024c-.156-.12-.156-.132-.156-.154l-.024-.139c-.065.019-.065.019-.113-.178l-.12-.048-.012-.127-.113-.024-.031-.106c-.065-.007-.065-.007-.065-.3V7.384l.156-.019.094.091-.173.017a.7.7,0,0,1,.019.192l.2.156.012.132.1.036c.036.029.06.154.072.173.072.041.1.192.1.192l.089.065.144-.012c.067-.12.077-.12.1-.12-.034,0,.012-.168.012-.168l.12-.125-.012-.173c0-.055,0-.055.228-.079l-.1-.507-.144-.187.185-.094.2.036.084.329.238.2v.12l-.281.079-.144.2.012.317a1.137,1.137,0,0,1,.091.149l-.127.072-.118-.166-.168.137.156.209Zm.163-.893a.975.975,0,0,1,.012.175l-.12.137c-.048.144-.055.192-.079.2l.235-.154.065.065a.016.016,0,0,1-.012-.017l-.012-.377.048-.072a.845.845,0,0,1-.137.041m.1-.855-.156.065.18.132.053.562.1-.13.262-.043-.262-.228-.079-.322Z",
    transform: "translate(-92.087 4.967)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8225",
    "data-name": "Caminho 8225",
    d: "M144.338,7.8l.125-.072V7.6l-.125-.029-.031-.036.108.012.18-.012.053-.024c-.029.053-.041.053-.053.053l-.089.043v.137l.281.029s0,.055-.012.055-.281-.065-.281-.065l-.175.106Z",
    transform: "translate(-91.673 5.362)",
    fill: "#613f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8226",
    "data-name": "Caminho 8226",
    d: "M144.286,7.914l.053-.137.127-.079-.036-.137.065.024V7.561l.113-.041v.029l-.077.065.019.115c.269.012.269.012.269.029-.043.072-.043.072-.324.012Z",
    transform: "translate(-91.688 5.372)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8227",
    "data-name": "Caminho 8227",
    d: "M145.173,7.288l-.156.125-.108.18-.048.005-.166-.2h-.18l-.1.245-.065-.01-.192-.2s-.053-.1-.043-.1l.468.005V7.127a.587.587,0,0,1-.113-.048c.024-.007.257-.007.257-.007l-.1.06v.192l.413.005Z",
    transform: "translate(-91.809 5.052)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8228",
    "data-name": "Caminho 8228",
    d: "M144.438,7.72l-.079-.012-.233-.245-.036-.132.516-.022-.048-.156.048-.031a.273.273,0,0,1-.06.019c-.043-.1.048-.1.2-.1h.156l-.221.156.017.142.48-.077-.24.377-.1.012-.156-.209-.137.029c.024.012-.043.185-.055.209Zm.2-.358-.5.041.264.216a1.315,1.315,0,0,0,.089-.216l.156-.012Z",
    transform: "translate(-91.828 5.032)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8229",
    "data-name": "Caminho 8229",
    d: "M144.263,7.265h.041c.024,0,.036.012.036.024V7.33a.032.032,0,0,1-.036.036h-.041a.032.032,0,0,1-.036-.036V7.289c0-.012.012-.024.036-.024",
    transform: "translate(-91.73 5.19)",
    fill: "#613f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8230",
    "data-name": "Caminho 8230",
    d: "M144.557,7.251h.036a.032.032,0,0,1,.036.036v.029a.032.032,0,0,1-.036.036h-.036a.034.034,0,0,1-.031-.036V7.287a.034.034,0,0,1,.031-.036",
    transform: "translate(-91.517 5.18)",
    fill: "#613f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8231",
    "data-name": "Caminho 8231",
    d: "M144.144,7.172l-.06-.029.024-.06a1.459,1.459,0,0,1,.466-.132,1.812,1.812,0,0,1,.557.036,2.017,2.017,0,0,1-.533.065,1.763,1.763,0,0,0-.454.12",
    transform: "translate(-91.833 4.959)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8232",
    "data-name": "Caminho 8232",
    d: "M144.28,6.934h-.144l-.185-.2.1.019.132.053Z",
    transform: "translate(-91.928 4.808)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8233",
    "data-name": "Caminho 8233",
    d: "M144.432,7.019H144.2l-.336-.324.4.091Z",
    transform: "translate(-91.99 4.783)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8234",
    "data-name": "Caminho 8234",
    d: "M144.646,6.906l.31-.233-.094-.012-.127.1-.13.024Z",
    transform: "translate(-91.461 4.758)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8235",
    "data-name": "Caminho 8235",
    d: "M144.724,6.884l-.49.019.012-.055.18-.017.017-.072h.06l.029.072.18.029Z",
    transform: "translate(-91.725 4.828)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8236",
    "data-name": "Caminho 8236",
    d: "M144.2,6.94l.012-.108.233-.06-.1.067.142-.012-.01-.055.269.024.041.079-.029.046Z",
    transform: "translate(-91.748 4.838)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8237",
    "data-name": "Caminho 8237",
    d: "M144.578,6.764h-.168l-.005-.089Z",
    transform: "translate(-91.603 4.768)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8238",
    "data-name": "Caminho 8238",
    d: "M144.414,6.675l-.012.089-.168.036Z",
    transform: "translate(-91.726 4.768)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8239",
    "data-name": "Caminho 8239",
    d: "M143.821,7.8l.077-.209-.065-.144-.077.209Z",
    transform: "translate(-92.067 5.319)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8240",
    "data-name": "Caminho 8240",
    d: "M143.929,7.821l.108-.245-.2.2Z",
    transform: "translate(-92.007 5.411)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8241",
    "data-name": "Caminho 8241",
    d: "M143.957,7.9l-.132-.065.18-.271-.12.259.055.012-.048-.019.113-.257Z",
    transform: "translate(-92.018 5.399)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8242",
    "data-name": "Caminho 8242",
    d: "M142.657,7.369l-.17.041.012.3-.2.048-.149.257.089.079c0,.012-.065.2-.065.2s.055.065.055.065l.048.168.144.012.034.192.209.034.2.139.014.089.233.007.154.041.533-.06.077-.108V8.717l.288-.007.036-.24h.142l-.012-.281.141.012-.048-.125-.081-.108L144.33,7.8l-.233-.221-.041-.286-.149-.067c0-.012-.005-.2-.005-.2l.159-.228-.015-.094H143.9l-.125.094-.146.019v.065l.036.132H143.5l-.012-.2-.245-.12-.233.149-.012.18-.108.031-.113-.163-.2-.072-.115-.005v.125l.209.269Z",
    transform: "translate(-93.212 4.785)",
    fill: "#fbfc2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8243",
    "data-name": "Caminho 8243",
    d: "M143.272,9.11l-.425-.053-.005-.127-.18-.106-.2-.031-.084-.226-.084.024-.132-.353a.679.679,0,0,1,.053-.127l-.089-.1.144-.264.233-.072-.041-.245.2-.082-.024-.115-.2-.24V6.782l.166.007.2.077.144.185.024-.185c0-.024,0-.024.257-.192l.3.115.029.245.079-.048-.031-.065c-.012-.132-.012-.132.185-.156l.091-.079.18-.012h.041l.024.132-.18.269.024.168c0-.036.108.019.108.019l.1.322.209.2.144.418-.192.06.079.216-.2.048.019.2-.329.055.041.1-.084.144Zm-.144-.149.156.048.52-.053.048-.091V8.733l.329-.058-.017-.192.2-.048-.065-.216.192-.041-.156-.156-.036-.2-.216-.192-.06-.31c-.149-.048-.149-.048-.149-.079l-.007-.2.175-.257-.12-.012-.091.077a.923.923,0,0,1-.166.024c.077.144.077.144.077.156l-.221.048-.053-.245-.223-.072c.012.012-.144.113-.178.137a.61.61,0,0,1,0,.149v.036l-.132.043-.18-.185-.168-.055-.046.072.19.24-.012.2-.2.084.041.245-.238.089-.1.24c.1.065.1.065.043.221-.036-.017-.036-.012.024.072l.065.168.091-.012.077.226h.173l.252.156.005.108Z",
    transform: "translate(-93.229 4.767)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8244",
    "data-name": "Caminho 8244",
    d: "M142.233,7.845l.245-.012.043.209.082.067.007.394.077.029.024-.154.192-.019.017.317-.029.036.024.048.209-.007s.043-.077.055-.077l.118-.012.048.089.043-.106s.113-.06.113-.048l.091.144.161-.024-.1-.084-.036-.2.221-.12.077.144s.091.012.091,0a1.252,1.252,0,0,1-.1-.168V7.947l.166-.233.233-.029v-.1l-.233-.216-.065-.293-.12-.065-.036.036-.156.017.156.209V7.42l.065.036-.022.377a1.387,1.387,0,0,0-.163.036l-.012.209-.1.1-.053.2a.828.828,0,0,0-.1.125h-.185l-.113-.1-.012-.144-.079-.024-.041-.168L142.915,8v-.1l-.137-.055s-.012-.082-.012-.094a.358.358,0,0,0-.067-.031V7.48l.115-.024-.067-.065-.024-.072V7.247l.091-.091-.156-.012-.156.067-.012.288-.18.058-.142.223Z",
    transform: "translate(-93.201 5.01)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8245",
    "data-name": "Caminho 8245",
    d: "M142.88,8.819l-.024-.084V8.372l-.132.058.024.115-.012.06L142.6,8.55l-.046-.437-.12-.262-.2.053-.084-.077.132-.3.2-.077a1,1,0,0,1-.017-.233.738.738,0,0,1,.173-.108c.053,0,.2.012.2.012l-.072.257-.084-.053.084-.132a.49.49,0,0,1-.089.005c.029.007-.055.043-.113.055V7.5l-.223.1-.113.209.257-.029.1.257.094.466-.005-.137.233-.055.084.353-.031.048.223-.036V8.8Zm.73-.01c-.156-.192-.156-.192-.156-.2l-.053.048V8.67l-.019-.065c.108-.055.12-.055.132-.055l.132.175.108-.048-.12-.007-.053-.221.257-.18.053.072c0-.012,0-.012-.012-.024l-.012-.365.053-.077c-.041.017-.106.029-.142.041a1.029,1.029,0,0,1,.012.18l-.12.125c-.067.216-.067.216-.089.216l-.067.108-.221.024c-.156-.132-.156-.132-.156-.161l-.024-.139c-.077.012-.077.007-.113-.173l-.12-.053-.012-.127-.108-.024-.036-.106c-.065-.012-.065-.012-.065-.3V7.437l.156-.019.1.084-.18.031c.036.029.036.161.036.185l.185.156.012.125.1.043c.029.024.053.154.065.173.079.036.1.192.1.192s.084.065.084.065l.144-.012c.077-.12.077-.12.1-.12-.024,0,.026-.168.026-.168l.106-.125V7.874c0-.055,0-.055.211-.077l-.1-.516-.144-.185.185-.089.2.029.089.329.228.209v.115l-.276.084-.144.2.012.322a.751.751,0,0,1,.091.144l-.127.077-.118-.173-.168.144.156.209Zm.269-1.749-.156.06.18.137.053.557.1-.132.262-.041-.262-.223-.079-.322Z",
    transform: "translate(-93.214 5.005)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8246",
    "data-name": "Caminho 8246",
    d: "M142.756,7.844l.125-.065V7.647l-.125-.036-.031-.036.12.012.168-.012.055-.017c-.031.053-.043.053-.055.053l-.089.041.012.132.262.029-.005.062-.281-.067-.18.1Z",
    transform: "translate(-92.803 5.399)",
    fill: "#613f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8247",
    "data-name": "Caminho 8247",
    d: "M142.705,7.958l.041-.132.139-.084-.036-.125.065.019V7.617l.115-.041V7.6l-.079.065.024.108c.264.017.264.017.264.036-.031.077-.031.077-.324.012Z",
    transform: "translate(-92.818 5.412)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8248",
    "data-name": "Caminho 8248",
    d: "M143.591,7.349l-.168.12-.1.18-.048.005-.154-.2-.175.007s-.1.238-.1.245l-.077-.012-.18-.2s-.065-.1-.053-.1h.466l-.012-.214a.881.881,0,0,1-.1-.043,2.022,2.022,0,0,1,.257-.012l-.1.072V7.38h.413Z",
    transform: "translate(-92.938 5.087)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8249",
    "data-name": "Caminho 8249",
    d: "M142.866,7.767l-.091-.007-.233-.238-.029-.132.507-.024-.041-.149.031-.031a.188.188,0,0,1-.043.012c-.048-.1.043-.108.2-.108h.168l-.245.156.036.156.473-.084-.247.384-.094.012L143.1,7.5l-.12.024a1.906,1.906,0,0,1-.072.211Zm.185-.353-.5.041.269.223a1.34,1.34,0,0,0,.084-.223l.156-.022Z",
    transform: "translate(-92.955 5.065)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8250",
    "data-name": "Caminho 8250",
    d: "M142.681,7.313h.048c.017,0,.029.019.029.036v.036c0,.024-.012.036-.029.036h-.048a.032.032,0,0,1-.036-.036V7.349a.035.035,0,0,1,.036-.036",
    transform: "translate(-92.86 5.224)",
    fill: "#613f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8251",
    "data-name": "Caminho 8251",
    d: "M142.975,7.3h.048c.012,0,.017.019.017.041v.031c0,.024-.005.036-.017.036h-.048a.039.039,0,0,1-.029-.036V7.341a.05.05,0,0,1,.029-.041",
    transform: "translate(-92.645 5.215)",
    fill: "#613f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8252",
    "data-name": "Caminho 8252",
    d: "M142.566,7.212l-.053-.024.017-.06A1.414,1.414,0,0,1,143,7a1.733,1.733,0,0,1,.533.041,1.931,1.931,0,0,1-.521.06,1.4,1.4,0,0,0-.442.108",
    transform: "translate(-92.955 4.997)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8253",
    "data-name": "Caminho 8253",
    d: "M142.7,6.984h-.132l-.2-.2.1.012.149.053Z",
    transform: "translate(-93.059 4.848)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8254",
    "data-name": "Caminho 8254",
    d: "M142.846,7.07h-.221l-.336-.329.389.089Z",
    transform: "translate(-93.115 4.815)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8255",
    "data-name": "Caminho 8255",
    d: "M143.071,6.961l.31-.233-.1-.019-.125.108-.132.024Z",
    transform: "translate(-92.591 4.793)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8256",
    "data-name": "Caminho 8256",
    d: "M143.143,6.936l-.49.012.012-.048.178-.024.024-.065h.043l.041.065.18.029Z",
    transform: "translate(-92.855 4.865)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8257",
    "data-name": "Caminho 8257",
    d: "M142.621,6.993l.012-.108.233-.06-.1.067.156-.012-.019-.055.264.024.041.079-.029.041Z",
    transform: "translate(-92.877 4.875)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8258",
    "data-name": "Caminho 8258",
    d: "M143.012,6.8l-.18.012-.012-.089Z",
    transform: "translate(-92.735 4.806)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8259",
    "data-name": "Caminho 8259",
    d: "M142.832,6.727l-.012.089-.168.024Z",
    transform: "translate(-92.855 4.805)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8260",
    "data-name": "Caminho 8260",
    d: "M142.24,7.852l.089-.209L142.24,7.5l-.065.209Z",
    transform: "translate(-93.196 5.356)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8261",
    "data-name": "Caminho 8261",
    d: "M142.347,7.873l.108-.245-.2.2Z",
    transform: "translate(-93.137 5.449)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8262",
    "data-name": "Caminho 8262",
    d: "M142.381,7.951l-.137-.072.178-.264-.125.259.06.012-.048-.024.125-.252Z",
    transform: "translate(-93.147 5.436)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8263",
    "data-name": "Caminho 8263",
    d: "M145.051,13.552l.545-6.29,3.333-1.922,2.58,2.789L149.8,14.194a32.781,32.781,0,0,0-4.745-.641",
    transform: "translate(-91.142 3.815)",
    fill: "#1e2788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8264",
    "data-name": "Caminho 8264",
    d: "M149.808,14.23l-.024-.005a31.4,31.4,0,0,0-4.733-.646l.521-6.309,3.344-1.939,2.609,2.8Zm-.891-8.863-3.31,1.927-.531,6.266a28.864,28.864,0,0,1,4.7.622l1.712-6.045Z",
    transform: "translate(-91.142 3.808)",
    fill: "#160080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8265",
    "data-name": "Caminho 8265",
    d: "M143.467,8.743l-.156.041v.3l-.2.041-.132.264.077.077a1.785,1.785,0,0,0-.053.2l.041.065.06.168.132.012.029.192.211.029.214.149v.091h.233l.156.048.533-.06.077-.12v-.149l.3-.012.029-.235h.149l-.022-.274.13.012-.029-.132-.079-.1-.022-.168-.223-.221-.048-.3-.154-.072-.012-.185.166-.228-.012-.094h-.154l-.108.094-.156.019v.065l.048.132h-.18v-.2l-.257-.125-.221.154c0,.007-.012.185-.012.185l-.12.026-.113-.163-.2-.077h-.1v.125l.2.269Z",
    transform: "translate(-92.623 5.763)",
    fill: "#fbfc2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8266",
    "data-name": "Caminho 8266",
    d: "M144.084,10.485l-.413-.055-.024-.13-.173-.1-.192-.029-.077-.228-.1.024-.144-.4-.012-.18.132-.262.245-.067-.053-.25.2-.084-.012-.12-.2-.233-.012-.156.012-.06.142.012.223.072.13.2.036-.2c0-.012,0-.012.257-.19l.3.118.017.247.091-.043-.043-.072c0-.132,0-.132.2-.156l.091-.07.173-.014h.048l.024.127-.18.269.024.156c0-.024.108.024.108.024l.089.334.2.2.149.425-.18.048.079.216-.2.06.012.2-.329.053.041.1-.089.142Zm-.144-.144.168.048.521-.072.041-.084v-.125l.334-.053-.022-.2.2-.043-.077-.221.185-.036-.156-.156-.017-.2-.216-.19-.065-.317c-.144-.043-.144-.043-.144-.084l-.012-.185.168-.259-.127-.012-.07.079c-.024.005-.156.024-.18.024.077.144.077.144.077.156l-.221.053-.06-.252-.209-.077c.012.017-.144.12-.173.144a.663.663,0,0,1,0,.154v.031l-.144.041-.168-.185-.18-.06-.046.079.2.238-.012.2-.2.079.046.25-.245.091-.106.24c.094.053.094.07.041.19-.041.007-.036.012.036.108l.053.168.1-.012.072.221.166-.007.24.163.017.113Z",
    transform: "translate(-92.64 5.746)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8267",
    "data-name": "Caminho 8267",
    d: "M143.049,9.225l.245-.012.043.209.077.067.012.382.077.029.024-.149.192-.017.031.31-.043.043.012.048h.216l.06-.091c.012,0,.118-.012.118-.012a.78.78,0,0,0,.06.1l.031-.127.125-.036.084.151.156-.024-.084-.1-.048-.19.221-.12.089.149h.079l-.1-.18V9.309l.178-.228.233-.024V8.968l-.233-.221-.065-.293-.137-.072-.031.041-.156.012.156.221V8.8l.065.029-.01.389-.168.024-.007.216-.113.1a1.267,1.267,0,0,1-.065.2l-.091.127-.18.005s-.106-.1-.106-.108l-.024-.144a.644.644,0,0,0-.079-.024l-.029-.166-.139-.06-.005-.1-.113-.053a.372.372,0,0,0-.024-.1l-.055-.029a1.683,1.683,0,0,1-.012-.245l.108-.024-.053-.072-.019-.072V8.62l.084-.089-.166-.017a1.56,1.56,0,0,1-.156.07,2.209,2.209,0,0,1,0,.283l-.187.053-.142.233Z",
    transform: "translate(-92.618 5.987)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8268",
    "data-name": "Caminho 8268",
    d: "M143.7,10.191l-.024-.077.012-.365-.132.053.024.108-.012.072-.137-.06-.041-.43-.12-.264-.216.055-.089-.084.137-.293.209-.079c-.024-.012-.024-.2-.024-.233a.312.312,0,0,1,.365-.1l-.065.257-.079-.06.079-.125a.2.2,0,0,1-.1,0c.036.017-.053.041-.106.06a.77.77,0,0,1,0,.245l-.211.1-.137.209.281-.024.091.252.094.461v-.12l.228-.06.084.36-.029.041.233-.029-.012.094Zm.73-.024c-.144-.173-.144-.173-.144-.19l-.053.173-.144-.108-.065.019.106-.067v.055l.091.065.024-.024-.043-.113c.12-.055.132-.055.144-.055.043.055.12.175.12.175l.12-.048h-.132l-.053-.235.257-.166.053.06c0-.007,0-.007-.012-.019V9.312l.041-.065a.479.479,0,0,1-.13.041.772.772,0,0,1,0,.168l-.108.137c-.072.216-.072.216-.113.216.024.005-.043.1-.043.1l-.228.024c-.166-.125-.166-.125-.166-.154l-.007-.144c-.065.024-.077.012-.125-.18l-.12-.048-.012-.12-.108-.017-.024-.115c-.072-.012-.072-.012-.072-.3V8.814l.156-.024-.005-.005.1.084-.168.036a.621.621,0,0,1,.019.185c.065.024.065.024.089.137l.115.019.005.125.1.031a.65.65,0,0,1,.055.19c.1.031.1.187.1.187s.1.065.1.065l.144-.007c.067-.13.067-.137.091-.137-.024,0,.024-.168.024-.168l.106-.113V9.234c0-.043,0-.043.211-.065l-.1-.509-.132-.192.173-.089.2.029.1.336.228.2v.115l-.276.082-.132.2.012.312s.072.132.084.149l-.12.084-.13-.185-.156.137.144.216Zm.269-1.735-.156.06.175.137.07.557.084-.125.269-.048-.257-.223-.072-.327Z",
    transform: "translate(-92.633 5.985)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8269",
    "data-name": "Caminho 8269",
    d: "M143.587,9.217l.12-.065V9.013l-.12-.024-.048-.048.125.024.168-.012.055-.024c-.024.06-.036.048-.043.048a.621.621,0,0,0-.089.043v.132l.274.041c-.012,0,0,.048-.012.048s-.286-.06-.286-.06l-.168.108Z",
    transform: "translate(-92.222 6.378)",
    fill: "#613f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8270",
    "data-name": "Caminho 8270",
    d: "M143.522,9.333l.053-.137.132-.079-.041-.13.065.01v-.01l.115-.043.012.024-.079.065.012.108c.276.012.276.012.276.043-.048.072-.055.072-.324.012Z",
    transform: "translate(-92.234 6.389)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8271",
    "data-name": "Caminho 8271",
    d: "M144.417,8.718l-.168.12-.1.18-.053.012-.156-.211h-.173l-.1.252-.065-.012-.192-.2-.048-.108.461.005V8.545s-.065-.024-.1-.043c.024-.005.245-.005.245-.005l-.091.065v.18l.4.007Z",
    transform: "translate(-92.352 6.07)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8272",
    "data-name": "Caminho 8272",
    d: "M143.686,9.144l-.079-.012-.245-.238-.036-.139.516-.017-.048-.149.048-.036a.218.218,0,0,1-.055.017c-.048-.1.055-.108.2-.108h.168l-.233.156.024.149.485-.077-.245.382-.1.012-.168-.209-.125.024a1.946,1.946,0,0,1-.055.211Zm.2-.358-.5.048.269.221c.012-.036.036-.1.089-.221l.156-.024Z",
    transform: "translate(-92.374 6.045)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8273",
    "data-name": "Caminho 8273",
    d: "M143.505,8.685h.029a.034.034,0,0,1,.036.031v.041c0,.024-.012.029-.036.029h-.029c-.024,0-.036-.005-.036-.029V8.716a.034.034,0,0,1,.036-.031",
    transform: "translate(-92.272 6.204)",
    fill: "#613f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8274",
    "data-name": "Caminho 8274",
    d: "M143.788,8.672h.048a.05.05,0,0,1,.029.036v.041c0,.012-.024.019-.029.019h-.048a.017.017,0,0,1-.019-.019V8.708c0-.017.007-.036.019-.036",
    transform: "translate(-92.057 6.195)",
    fill: "#613f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8275",
    "data-name": "Caminho 8275",
    d: "M143.379,8.6l-.053-.036.012-.048a1.2,1.2,0,0,1,.478-.137,1.6,1.6,0,0,1,.545.036,1.773,1.773,0,0,1-.521.06,1.33,1.33,0,0,0-.461.125",
    transform: "translate(-92.374 5.976)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8276",
    "data-name": "Caminho 8276",
    d: "M143.526,8.361h-.144l-.192-.209.1.017.132.06Z",
    transform: "translate(-92.471 5.823)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8277",
    "data-name": "Caminho 8277",
    d: "M143.675,8.437h-.233l-.336-.324.4.091Z",
    transform: "translate(-92.531 5.795)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8278",
    "data-name": "Caminho 8278",
    d: "M143.881,8.339l.324-.24-.115-.017-.108.113-.142.007Z",
    transform: "translate(-92.007 5.773)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8279",
    "data-name": "Caminho 8279",
    d: "M143.966,8.3l-.49.019V8.278l.19-.024.014-.065s.053-.012.053,0l.041.06.18.029Z",
    transform: "translate(-92.267 5.846)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8280",
    "data-name": "Caminho 8280",
    d: "M143.445,8.365l.005-.108.228-.06-.1.072.154-.012-.022-.06.281.024.029.072-.029.048Z",
    transform: "translate(-92.289 5.855)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8281",
    "data-name": "Caminho 8281",
    d: "M143.829,8.185h-.18l-.012-.089Z",
    transform: "translate(-92.152 5.783)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8282",
    "data-name": "Caminho 8282",
    d: "M143.656,8.1l-.012.084-.168.029Z",
    transform: "translate(-92.267 5.785)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8283",
    "data-name": "Caminho 8283",
    d: "M143.052,9.226l.089-.209-.077-.149L143,9.089Z",
    transform: "translate(-92.608 6.334)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8284",
    "data-name": "Caminho 8284",
    d: "M143.176,9.248l.1-.252-.2.211Z",
    transform: "translate(-92.553 6.426)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8285",
    "data-name": "Caminho 8285",
    d: "M143.2,9.328l-.144-.072.18-.264-.113.259.058.012-.046-.019.113-.269Z",
    transform: "translate(-92.564 6.411)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8286",
    "data-name": "Caminho 8286",
    d: "M145.606,9.474l-.168.192.012.166h.348a.269.269,0,0,0,.166-.113c.019-.053,0-.089.012-.168Z",
    transform: "translate(-90.865 6.767)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8287",
    "data-name": "Caminho 8287",
    d: "M145.439,9.856l-.019-.185.175-.2.394.072-.012.185.012.012c-.024.043-.048.089-.18.12Z",
    transform: "translate(-90.878 6.762)",
    fill: "#d30028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8288",
    "data-name": "Caminho 8288",
    d: "M146.088,9.747l-.156.108-.012.156.312.022c.108-.01.12-.029.144-.077.041-.053.036-.053.041-.12Z",
    transform: "translate(-90.521 6.962)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8289",
    "data-name": "Caminho 8289",
    d: "M146.238,10.067l-.314-.024-.012-.18.156-.13.365.089-.051.144.022.012c-.036.053-.06.065-.166.089",
    transform: "translate(-90.527 6.952)",
    fill: "#d30028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8290",
    "data-name": "Caminho 8290",
    d: "M146.885,9.513l-.17.168.014.125.336.012c.1-.024.082-.012.118-.084.038-.053.026-.065.038-.137Z",
    transform: "translate(-89.953 6.795)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8291",
    "data-name": "Caminho 8291",
    d: "M147.072,9.847l-.334-.017-.036-.144.178-.18.348.072-.036.161.024.012c-.048.067-.048.067-.144.1",
    transform: "translate(-89.963 6.79)",
    fill: "#d30028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8292",
    "data-name": "Caminho 8292",
    d: "M147.452,9.687l-.192.156V10l.348.036a.212.212,0,0,0,.156-.1c.029-.048.005-.053.017-.132Z",
    transform: "translate(-89.564 6.92)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8293",
    "data-name": "Caminho 8293",
    d: "M147.62,10.054l-.355-.031-.012-.178.182-.161.365.094-.014.175a.236.236,0,0,1-.166.1",
    transform: "translate(-89.569 6.917)",
    fill: "#d30028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8294",
    "data-name": "Caminho 8294",
    d: "M146.011,7.431l.653.437c.125-.1.377-.043.49-.012.166.048.3.149.454.178a3.169,3.169,0,0,0,.891.1,2.153,2.153,0,0,0,.677-.269V7.8h-.127a1.626,1.626,0,0,1-.73.048c-.221-.024-.274-.125-.61-.226l-.034-.055a1.413,1.413,0,0,0,.669-.065,1.066,1.066,0,0,0,.331-.216V7.215h-.132a.652.652,0,0,1-.492.1c-.221-.024-.418-.144-.567-.149s-.156-.072-.3-.084a2.383,2.383,0,0,0-.719.072.83.83,0,0,0-.454.281",
    transform: "translate(-90.456 5.053)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8295",
    "data-name": "Caminho 8295",
    d: "M148.349,8.168a3.3,3.3,0,0,1-.747-.1.912.912,0,0,1-.233-.091,1.232,1.232,0,0,0-.223-.089.574.574,0,0,0-.466,0L146,7.462a.691.691,0,0,1,.454-.322,2.618,2.618,0,0,1,.73-.072.546.546,0,0,1,.156.041.219.219,0,0,0,.142.043.715.715,0,0,1,.252.065,1.087,1.087,0,0,0,.317.077.646.646,0,0,0,.49-.089V7.2l.132.019-.012.019.012-.014V7.24c-.012,0-.012.012-.017.012l-.048.125a.656.656,0,0,1-.264.151.782.782,0,0,1-.394.07h-.108l.108-.041a.8.8,0,0,0,.382-.072.6.6,0,0,0,.24-.144l.084-.089a1.168,1.168,0,0,1-.605.089,1.322,1.322,0,0,1-.329-.089.98.98,0,0,0-.24-.06.3.3,0,0,1-.161-.041.391.391,0,0,0-.137-.043,2.506,2.506,0,0,0-.718.067.688.688,0,0,0-.389.233l.6.442c.043-.065.233-.077.478-.005a1.722,1.722,0,0,1,.233.082.7.7,0,0,0,.223.1,2.72,2.72,0,0,0,.891.091,1.487,1.487,0,0,0,.574-.2l-.024-.077a1.592,1.592,0,0,1-.73.053.874.874,0,0,1-.286-.1,1.668,1.668,0,0,0-.336-.127l.077-.029c.132.048.211.089.276.113a.9.9,0,0,0,.269.1,1.543,1.543,0,0,0,.718-.06h.137l-.077.154a1.609,1.609,0,0,1-.593.216,1.274,1.274,0,0,1-.161.012",
    transform: "translate(-90.461 5.046)",
    fill: "#ba0019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8296",
    "data-name": "Caminho 8296",
    d: "M146.087,7.253a1.68,1.68,0,0,1,.18.065c.053.024.029.024.084.067-.007-.055,0-.055-.031-.091a1.009,1.009,0,0,0-.144-.106Z",
    transform: "translate(-90.402 5.135)",
    fill: "#82373b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8297",
    "data-name": "Caminho 8297",
    d: "M146.46,7.619a.349.349,0,0,0-.053-.149.384.384,0,0,0-.079-.139.179.179,0,0,1,.12.084.319.319,0,0,1,.053.18Z",
    transform: "translate(-90.23 5.237)",
    fill: "#82373b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8298",
    "data-name": "Caminho 8298",
    d: "M146.475,7.1a.558.558,0,0,1,.077.156c.012.072.024.173.024.173a.828.828,0,0,1,0-.173c-.012-.055-.036-.108-.041-.156Z",
    transform: "translate(-90.125 5.07)",
    fill: "#82373b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8299",
    "data-name": "Caminho 8299",
    d: "M146.786,7.118l.024.31.036-.293Z",
    transform: "translate(-89.903 5.085)",
    fill: "#82373b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8300",
    "data-name": "Caminho 8300",
    d: "M146.733,7.622a.622.622,0,0,0,0-.149c-.012-.055-.024-.1-.041-.156a.391.391,0,0,1,.094.161.2.2,0,0,1-.053.144",
    transform: "translate(-89.97 5.227)",
    fill: "#82373b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8301",
    "data-name": "Caminho 8301",
    d: "M147.076,7.418a.48.48,0,0,1-.012.173c-.019.084-.029.084-.089.132.07-.048.125-.065.142-.113a.321.321,0,0,0-.041-.192",
    transform: "translate(-89.767 5.299)",
    fill: "#82373b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8302",
    "data-name": "Caminho 8302",
    d: "M147.125,7.452c-.048.012-.048-.144-.077-.228.017-.005.029,0,.053.043.024.012.012.12.024.185",
    transform: "translate(-89.715 5.159)",
    fill: "#82373b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8303",
    "data-name": "Caminho 8303",
    d: "M147.306,7.379l.024-.132h.041v.1c0,.012-.053.036-.065.036",
    transform: "translate(-89.531 5.177)",
    fill: "#82373b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8304",
    "data-name": "Caminho 8304",
    d: "M147.292,7.523a.562.562,0,0,1,.065.137c.012.043-.012.067-.041.127l.065.005a.146.146,0,0,0,.036-.132c0-.048-.024-.077-.072-.118Z",
    transform: "translate(-89.541 5.374)",
    fill: "#82373b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8305",
    "data-name": "Caminho 8305",
    d: "M147.4,7.811l-.077-.005.024-.151-.067-.125a.1.1,0,0,1,.043.012h-.031l.1.113a.23.23,0,0,1-.036.115l.036.017-.024-.012a.121.121,0,0,0,.036-.12l-.048-.1c.072.024.1.053.1.1a.241.241,0,0,1-.036.144Z",
    transform: "translate(-89.549 5.379)",
    fill: "#83353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8306",
    "data-name": "Caminho 8306",
    d: "M147.554,7.544l.019.185.046-.029-.012-.156Z",
    transform: "translate(-89.354 5.389)",
    fill: "#82373b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8307",
    "data-name": "Caminho 8307",
    d: "M146.3,7.307a.6.6,0,0,0-.264.2l-.423-.221a.218.218,0,0,0-.067.226.765.765,0,0,0,.269.264,1.739,1.739,0,0,1-.1.31c-.055.115-.144.252-.156.3s-.012.156.067.192a3.187,3.187,0,0,0,.411-.019.46.46,0,0,0-.048.156c.012.029.036.041.1.041-.012.048-.055.1-.031.127a.224.224,0,0,0,.163.029c-.031.031-.079.072-.132.132a1.562,1.562,0,0,0-.209.209c-.067.1-.079.2.053.192-.041.053-.089.1-.089.156s.048.089.13.053a.685.685,0,0,0,0,.377,1.022,1.022,0,0,0-.041.31c-.089.055-.1.12-.168.235s-.166.154-.221.413l.377.094c.012-.053.065-.089.077-.144a.283.283,0,0,0,.012-.173,2.492,2.492,0,0,0,.276-.459.491.491,0,0,1,.216-.079c.053,0,.094.036.166.079a1.036,1.036,0,0,0-.113.358v.394c-.024.091-.132.091-.185.389l.341.1c.065-.1.156-.12.178-.156l.019-.413c.048-.19.324-.358.324-.555a.494.494,0,0,0,.178-.012.288.288,0,0,0,.108-.091c.012.067.06.067.1.067a.538.538,0,0,0,.168-.077c.024.034.031.065.091.077a1.136,1.136,0,0,0,.245-.019l-.281.456c-.012.048.012.077-.024.118-.007.055-.055.072-.072.12l.322.072.043-.137a.353.353,0,0,0,.168-.084c.029-.036.029-.125.053-.173a4.348,4.348,0,0,0,.4-.389.374.374,0,0,1,.233.18.96.96,0,0,1-.036.442l-.2.324-.024.058.322.108.209-.154v-.223a1.563,1.563,0,0,1,.4-.4,1.79,1.79,0,0,0,.012-.25c-.036-.024-.065-.012-.065-.067a.761.761,0,0,1,0-.233c.012-.024.053-.053.053-.077-.053-.055-.029-.221-.024-.348,0-.142.2-.31.223-.389l.024-.154c-.024-.031-.055-.06-.055-.091a.282.282,0,0,1,.055-.113l.048-.065V8.523a.191.191,0,0,0-.084-.108.233.233,0,0,0-.12.072l-.192.137a.456.456,0,0,1-.317,0h-.245a.356.356,0,0,1-.312-.005H148.5a.762.762,0,0,1-.156.07.34.34,0,0,1-.156,0,.966.966,0,0,0-.389.072.788.788,0,0,0-.389-.06l-.12-.034a1.23,1.23,0,0,1-.4-.485.8.8,0,0,0,.588-.432L147,7.768Z",
    transform: "translate(-90.794 5.207)",
    fill: "#fbfc2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8308",
    "data-name": "Caminho 8308",
    d: "M146.732,11.575l-.353-.089a.494.494,0,0,1,.12-.341l.041-.466a.6.6,0,0,1,.069-.257l-.1-.144a.4.4,0,0,0-.206.06,4.172,4.172,0,0,1-.262.447.463.463,0,0,1-.012.18l-.1.144-.377-.089a.52.52,0,0,1,.132-.341l.115-.18a.419.419,0,0,1,.118-.161.977.977,0,0,1-.077.185.6.6,0,0,1-.118.185.546.546,0,0,0-.144.3l.365.072.041-.127A.375.375,0,0,0,146,10.78a4.172,4.172,0,0,0,.281-.466c.158-.091.257-.1.353-.036a.157.157,0,0,1,.026.168.468.468,0,0,0-.081.233v.394a1.087,1.087,0,0,0-.178.389l.322.065a.344.344,0,0,1,.113-.106l.067-.432a.841.841,0,0,1,.156-.262.478.478,0,0,0,.163-.293h.088l.038-.024.077.029-.166.007a.579.579,0,0,1-.158.31.6.6,0,0,0-.144.245l-.034.4a.573.573,0,0,0-.173.161Zm2.323-.077-.348-.113.221-.408a1.1,1.1,0,0,0,.038-.435.4.4,0,0,0-.221-.163,2.6,2.6,0,0,1-.391.389l-.06.173a.254.254,0,0,1-.132.079l-.065.137-.341-.065.072-.127-.019.067.271.089.017-.113c.113-.055.146-.067.168-.1l.065-.18a2.786,2.786,0,0,0,.389-.389.328.328,0,0,1,.281.192,1.061,1.061,0,0,1-.034.461l-.211.322.3.144.185-.156V11.1a1.108,1.108,0,0,1,.336-.37,1.247,1.247,0,0,0,.065-.281.431.431,0,0,1-.065-.3c0-.125.022-.281.036-.43a.5.5,0,0,1,.156-.281.65.65,0,0,0,.07-.115l.012-.144c-.053-.118-.031-.166,0-.209l.048-.437h-.012l-.156-.017-.192.137a.5.5,0,0,1-.329.007h-.244a.442.442,0,0,1-.324-.012l-.13.005a.508.508,0,0,1-.158.072L148.2,8.7v.024a.824.824,0,0,0-.31.048h-.132a.936.936,0,0,0-.334-.036l-.132-.048a1.208,1.208,0,0,1-.413-.483c.353-.127.49-.228.586-.456L147,7.788l-.706-.449a.608.608,0,0,0-.2.149l-.031-.012a.454.454,0,0,1,.238-.18l.7.461.48-.024c-.091.269-.233.377-.588.478a1.7,1.7,0,0,0,.4.444l.13.029a.661.661,0,0,1,.336.048,3.056,3.056,0,0,1,.428-.06l.156.007a.755.755,0,0,0,.132-.055l.17-.012a.385.385,0,0,0,.3,0h.257a.587.587,0,0,0,.312,0l.185-.137a.231.231,0,0,1,.125-.077.18.18,0,0,1,.1.13l.007.377-.1.18.036.245a.476.476,0,0,1-.077.125.485.485,0,0,0-.144.264c-.012.091-.029.281.026.336a.58.58,0,0,0-.067.322c.07.06.082.067.067.293a2.082,2.082,0,0,0-.4.432l-.012.214Zm-1.227-.545h-.007l.007-.13.293-.456a.3.3,0,0,1-.2.055l-.139-.072c-.118.1-.221.149-.274.005l.122.024c.01,0,.052-.005.152-.077l.1.077a1.866,1.866,0,0,0,.247-.024Zm-1.9-.634a.62.62,0,0,1,.036-.286.54.54,0,0,1,0-.372c-.089.043-.125.012-.137-.048a.22.22,0,0,1,.06-.125c.012.06-.012.089-.012.125l.041-.024.079.091a.492.492,0,0,0,0,.3,1.609,1.609,0,0,0-.019.269c-.024.031-.034.055-.048.072m-.063-.921c-.055-.043-.038-.091,0-.139a1.216,1.216,0,0,1,.166-.173l.178-.173c-.072.029-.111.029-.153,0l.041-.12v.031l.125.082-.074.127a2.64,2.64,0,0,0-.25.257c-.034.041-.048.084-.034.108m.233-.605-.122-.06a.362.362,0,0,1,.033-.144c-.014,0-.067.012-.11.012a1.234,1.234,0,0,1-.2.012.172.172,0,0,1-.144-.221.42.42,0,0,1,.067-.149c.024-.053.055-.108.077-.156a1.059,1.059,0,0,0,.1-.3.586.586,0,0,1-.259-.252.239.239,0,0,1,.067-.257l.281.144-.281-.1a.194.194,0,0,0-.029.192.861.861,0,0,0,.25.264,1.01,1.01,0,0,1-.084.322,1.447,1.447,0,0,1-.089.168.583.583,0,0,0-.055.132c-.012.072-.022.142.032.166a.971.971,0,0,0,.255-.012c.055,0,.108-.005.144-.005Z",
    transform: "translate(-90.802 5.2)",
    fill: "#e8d629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8309",
    "data-name": "Caminho 8309",
    d: "M145.885,7.677l.137.06c.007.024.055.036.079.041s.029-.017.053-.036l.125-.065c-.07-.012-.1-.06-.166-.06a1,1,0,0,0-.228.06",
    transform: "translate(-90.546 5.441)",
    fill: "#624e0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8310",
    "data-name": "Caminho 8310",
    d: "M146.106,7.807l-.228-.113h.012V7.682h.024a.335.335,0,0,1,.2-.072l.12.053-.12-.024-.18.055.168.089v0l.024-.041.132-.067.029.019Z",
    transform: "translate(-90.551 5.436)",
    fill: "#624e0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8311",
    "data-name": "Caminho 8311",
    d: "M146.09,8.757c0,.012-.019.019-.031.012a1.042,1.042,0,0,0-.1-.4,1.408,1.408,0,0,1,.132.389",
    transform: "translate(-90.494 5.977)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8312",
    "data-name": "Caminho 8312",
    d: "M146.54,8.758a.108.108,0,0,0,.077-.007c.012-.034-.024-.082-.036-.113-.041-.1-.077-.2-.094-.238a.019.019,0,0,0-.036.01c.036.084.077.317.089.348",
    transform: "translate(-90.142 5.993)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8313",
    "data-name": "Caminho 8313",
    d: "M146.823,8.741c0,.024-.065,0-.077-.029a2.465,2.465,0,0,1-.067-.372c.012-.005.067.108.091.161,0,.031.041.144.053.24",
    transform: "translate(-89.982 5.957)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8314",
    "data-name": "Caminho 8314",
    d: "M146.723,9.182c0,.017.053,0,.077-.019.055-.089.132-.185.156-.226s.077-.293.053-.293c0-.007-.065.13-.13.257a2.648,2.648,0,0,0-.156.281",
    transform: "translate(-89.948 6.175)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8315",
    "data-name": "Caminho 8315",
    d: "M146.742,9.182l-.024-.012c-.012-.029-.012-.041.144-.31l.089-.163c.012-.012.012-.012.024-.012l-.077.2a1.115,1.115,0,0,0-.144.269l-.012-.012v.024l.132-.175a1.023,1.023,0,0,0,.108-.293c.058.024,0,.216-.007.216Z",
    transform: "translate(-89.955 6.204)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8316",
    "data-name": "Caminho 8316",
    d: "M146.983,9.121c-.024.007.048-.221.048-.264.012-.065.029-.178.053-.322a.886.886,0,0,1-.1.586",
    transform: "translate(-89.765 6.097)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8317",
    "data-name": "Caminho 8317",
    d: "M146.994,9.161l-.024-.024c-.012-.012-.012-.029.024-.185l.077-.42a.7.7,0,0,1-.053.6Z",
    transform: "translate(-89.776 6.095)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8318",
    "data-name": "Caminho 8318",
    d: "M147.218,8.6a1.431,1.431,0,0,1-.192-.31,1.7,1.7,0,0,1,.18.233.117.117,0,0,1,.012.077",
    transform: "translate(-89.732 5.92)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8319",
    "data-name": "Caminho 8319",
    d: "M147.44,8.8c-.012-.019-.012-.108-.031-.221a.966.966,0,0,1-.07-.252c.012-.012.036,0,.07.012.007.06.031.3.062.442,0,.012-.007.019-.031.019",
    transform: "translate(-89.509 5.948)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8320",
    "data-name": "Caminho 8320",
    d: "M147.579,8.438c-.012-.012.041.113.089.257a3.19,3.19,0,0,0,.079.389c.017-.012.017-.041.053-.048s.209,0,.2-.005a1.452,1.452,0,0,1-.257-.257,1.431,1.431,0,0,1-.168-.336",
    transform: "translate(-89.337 6.027)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8321",
    "data-name": "Caminho 8321",
    d: "M147.739,9.1h-.024l-.012-.132c-.017-.077-.029-.2-.053-.274s-.055-.156-.067-.2c0,0,0,.007.012.007-.012-.019-.024-.031-.024-.048.036.041.055.077.079.106.036.06.065.127.108.187a1.184,1.184,0,0,0,.214.209Z",
    transform: "translate(-89.342 6.037)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8322",
    "data-name": "Caminho 8322",
    d: "M148.845,8.165a23.657,23.657,0,0,1,2.693.711,26.452,26.452,0,0,1,2.544.975l-1.4,2.849c-.8-.305-1.569-.538-2.359-.79-.771-.245-1.531-.471-2.316-.711Z",
    transform: "translate(-89.03 5.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8323",
    "data-name": "Caminho 8323",
    d: "M152.682,12.735l-.012-.012c-.677-.252-1.335-.468-2-.677l-.353-.113c-.526-.168-1.06-.329-1.581-.485l-.73-.228.833-3.058a23.136,23.136,0,0,1,2.71.694,26.888,26.888,0,0,1,2.537.982Zm-3.837-4.543-.819,3.01.723.2c.521.156,1.054.324,1.586.49l.348.115c.651.209,1.31.425,1.975.675l1.412-2.835c-.725-.288-1.587-.641-2.532-.946a24.094,24.094,0,0,0-2.693-.706",
    transform: "translate(-89.03 5.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8324",
    "data-name": "Caminho 8324",
    d: "M148.6,8.556s1.322.293,2.585.706,2.513.933,2.513.933-.8,1.634-.8,1.634c-.777-.31-1.574-.6-2.374-.855s-1.593-.5-2.412-.687Z",
    transform: "translate(-88.958 6.112)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8325",
    "data-name": "Caminho 8325",
    d: "M152.908,11.856h-.024c-.742-.3-1.532-.586-2.364-.855-.754-.245-1.567-.5-2.412-.689l.468-1.759a22.686,22.686,0,0,1,2.609.694,26.381,26.381,0,0,1,2.5.933c-.115-.01-1.269-.5-2.508-.9-1.257-.406-2.566-.694-2.59-.706l-.456,1.711a20.621,20.621,0,0,1,2.4.67c.831.264,1.61.55,2.347.838.706-1.43.783-1.6.807-1.617a.1.1,0,0,1,.029.019c-.029.053-.586,1.2-.807,1.641Z",
    transform: "translate(-88.958 6.11)",
    fill: "#d30028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8326",
    "data-name": "Caminho 8326",
    d: "M148.515,9.118a.816.816,0,0,0,.293-.216h.454l.012.168c.12.048.173.113.3.168.108.06.274.1.389.156l1,.089a1.633,1.633,0,0,1,.442.144.639.639,0,0,1,.257.269,4.727,4.727,0,0,0,.617.144,5.213,5.213,0,0,0,.682.053c.108.036.108.089.053.149a.537.537,0,0,1-.425.144c-.31.012-.651-.173-.807-.144a.672.672,0,0,0,.353.365v.437l-.084.084-.1-.065a.355.355,0,0,0,.017-.336c-.06-.1-.06-.132-.2-.144a1.049,1.049,0,0,1-.454-.2l-.067.012a.43.43,0,0,1-.19.161l-.187-.005s-.454-.1-.454-.108-.012-.072,0-.077a1.363,1.363,0,0,1,.161-.007,1.242,1.242,0,0,0,.305.036v-.173l.3-.019c-.055-.209-.077-.346-.365-.394l-.879.031v.118a2.409,2.409,0,0,0-.821.036c-.113.007-.293.067-.37.067l-.084-.024c-.06-.019-.06-.036-.036-.091a1.143,1.143,0,0,0,.557-.106c.005-.038-.036-.115-.055-.115-.25-.012-.435,0-.5-.012-.1-.029-.245-.089-.245-.089s-.012-.091,0-.091l.156.036a1.166,1.166,0,0,0,.509-.012V9.435a.157.157,0,0,0-.055-.12c-.017-.005-.269-.029-.353-.029-.144-.031-.125-.108-.125-.168",
    transform: "translate(-88.765 6.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8327",
    "data-name": "Caminho 8327",
    d: "M152.055,11.163l-.113-.072a.431.431,0,0,0,.012-.341c-.067-.115-.079-.125-.18-.132a1.047,1.047,0,0,1-.42-.18,1.98,1.98,0,0,0,.42.132c.125.007.144.048.2.125.06.163.084.288,0,.389l.084.055-.024-.019.089-.084v-.418a.623.623,0,0,1-.358-.365.613.613,0,0,1,.346.036,2.237,2.237,0,0,0,.485.089.49.49,0,0,0,.4-.142,2.16,2.16,0,0,0-.711-.163,4.643,4.643,0,0,1-.629-.142.671.671,0,0,0-.257-.276,1.8,1.8,0,0,0-.43-.137l-1-.091c-.067-.024-.139-.053-.2-.084a1.815,1.815,0,0,1-.2-.07.846.846,0,0,1-.156-.091c-.048-.024-.089-.053-.144-.084l-.024-.178-.43.017a.386.386,0,0,1-.2.156c-.065.12-.065.156.036.18a1.259,1.259,0,0,1,.365.036.2.2,0,0,1,.067.13V9.57a.952.952,0,0,1-.533.043l-.1-.043.024-.024c.364.084.514.036.574,0l-.007-.1c-.065-.108-.305-.132-.389-.132-.144-.029-.144-.1-.144-.173V9.128l.084-.067a.437.437,0,0,0,.2-.161l.478-.012.031.192c.048,0,.089.036.149.06a.463.463,0,0,0,.144.089.856.856,0,0,0,.185.079c.065.029.132.053.2.082l.994.084a1.185,1.185,0,0,1,.454.156.706.706,0,0,1,.264.264,3.629,3.629,0,0,0,.6.13,6.792,6.792,0,0,0,.682.06h.024l.083.072c-.041.1-.155.257-.478.257a1.775,1.775,0,0,1-.5-.089,1.284,1.284,0,0,0-.281-.053.637.637,0,0,0,.336.322v.473Zm-.982-.569-.209-.012c-.466-.113-.466-.113-.466-.125.024-.1.029-.108.185-.108a1.743,1.743,0,0,0,.305.036l-.024-.149.2-.031-.173.048.019.156a.814.814,0,0,1-.329-.012h-.151a1.716,1.716,0,0,0,.449.144l.2.012a.425.425,0,0,0,.156-.156.386.386,0,0,0,.06.017.613.613,0,0,1-.216.18m.1-.418c-.077-.18-.115-.288-.353-.329l-.879.017.029.1a1.886,1.886,0,0,1-.37.012,1.8,1.8,0,0,0-.468.048,1.837,1.837,0,0,0-.2.041.565.565,0,0,1-.18.036l-.156-.072c.036-.005.048-.012.079-.017l.077.065v-.024a.565.565,0,0,0,.18-.036c.065-.005.132-.029.19-.029a1.975,1.975,0,0,1,.48-.053c.13,0,.262.01.353.017l-.048-.1.916-.048c.288.048.322.18.377.365Zm-2.364-.2a2.479,2.479,0,0,0,.365-.137l-.233-.084-.144.005-.168-.005c-.048-.012-.257-.077-.257-.115l.036-.034a.646.646,0,0,0,.221.1h.312l.19.012a.175.175,0,0,1,.072.144.769.769,0,0,1-.394.113",
    transform: "translate(-88.768 6.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8328",
    "data-name": "Caminho 8328",
    d: "M149.8,9.768a1.443,1.443,0,0,0,.437.077l.3-.017c-.053-.209-.077-.348-.365-.4l-.88.031v.12c.276.1.413.149.509.185",
    transform: "translate(-88.115 6.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8329",
    "data-name": "Caminho 8329",
    d: "M150.249,9.871h0A1.488,1.488,0,0,1,149.8,9.8c-.156-.065-.286-.113-.5-.192l-.034-.137.916-.048c.286.048.322.18.377.365l-.026.007c-.077-.18-.113-.288-.351-.329l-.881.017.031.1c.2.065.322.125.413.156a2.105,2.105,0,0,0,.5.1l.221-.024Z",
    transform: "translate(-88.13 6.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8330",
    "data-name": "Caminho 8330",
    d: "M140.025,14.216l-1.6-5.943,2.443-2.949,3.4,1.951.591,6.3a43.979,43.979,0,0,0-4.829.641",
    transform: "translate(-95.878 3.803)",
    fill: "#1e2788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8331",
    "data-name": "Caminho 8331",
    d: "M140.012,14.255v-.019l-1.6-5.942,2.448-2.981L144.3,7.259l.586,6.319c-1.783.156-2.938.334-4.846.67Zm.855-8.906-2.412,2.945,1.586,5.906a44.294,44.294,0,0,1,4.824-.639l-.6-6.273Z",
    transform: "translate(-95.888 3.795)",
    fill: "#160080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8332",
    "data-name": "Caminho 8332",
    d: "M136.027,8.033l.574.449-.1.8.747-.31.6.454.079-.73.622-.24-.509-.49.108-.73-.742.264c0-.012-.538-.449-.538-.442s-.12.687-.12.687Z",
    transform: "translate(-97.587 5.037)",
    fill: "#fbfc2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8333",
    "data-name": "Caminho 8333",
    d: "M137.88,9.475,137.246,9l-.735.31.077-.831-.574-.413.73-.346a3.342,3.342,0,0,1,.113-.677c.031-.005.569.432.574.432.024-.012.713-.264.713-.264l-.079.754.509.466-.629.288Zm-.634-.533.586.437.077-.689.634-.269-.52-.43.108-.754c-.7.3-.706.3-.718.3-.048-.036-.516-.437-.545-.456.019.019-.089.67-.089.67l-.737.317.593.4-.1.819Z",
    transform: "translate(-97.598 5.032)",
    fill: "#f4c627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8334",
    "data-name": "Caminho 8334",
    d: "M136.03,7.628l2.5.4-.622.252-.6-.42s.545,1.131.533,1.126-.581-.42-.6-.437l.053-.689-.79,1c0-.012.115-.8.115-.8Z",
    transform: "translate(-97.586 5.449)",
    fill: "#f4c427"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8335",
    "data-name": "Caminho 8335",
    d: "M136.438,7.752l.581.5-.449-1.2Z",
    transform: "translate(-97.294 5.038)",
    fill: "#f4c627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8336",
    "data-name": "Caminho 8336",
    d: "M136.855,7.443c.012.005-.089.723-.077.723.053-.084.831-1,.819-1s-.718.281-.742.276",
    transform: "translate(-97.052 5.12)",
    fill: "#f4c627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8337",
    "data-name": "Caminho 8337",
    d: "M150.123,7.124l.156.718-.61.533.778.245.154.723.545-.509.634.2-.065-.7.568-.485s-.747-.257-.747-.269a6.662,6.662,0,0,0-.12-.677c-.012,0-.545.444-.545.444Z",
    transform: "translate(-87.843 4.935)",
    fill: "#fbfc2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8338",
    "data-name": "Caminho 8338",
    d: "M150.595,9.4l-.161-.766-.771-.221.6-.569-.154-.7.776.2a4.868,4.868,0,0,1,.533-.449,3.776,3.776,0,0,1,.132.718c.048.007.735.24.735.24l-.555.521.077.675-.664-.185Zm-.466-2.239.18.694-.622.557.778.2.154.7.528-.478.652.2-.113-.677.579-.5a6.493,6.493,0,0,1-.747-.245c0-.036-.1-.646-.108-.682a5.989,5.989,0,0,1-.521.461Z",
    transform: "translate(-87.848 4.925)",
    fill: "#f4c627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8339",
    "data-name": "Caminho 8339",
    d: "M150.13,7.045l1.646,1.891-.639-.2-.18-.7s-.336,1.209-.336,1.2-.166-.687-.166-.706l.5-.5s-1.281.264-1.281.257.622-.526.622-.526Z",
    transform: "translate(-87.838 5.032)",
    fill: "#f4c627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8340",
    "data-name": "Caminho 8340",
    d: "M150.371,7.356l.12.747.437-1.2Z",
    transform: "translate(-87.342 4.93)",
    fill: "#f4c627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8341",
    "data-name": "Caminho 8341",
    d: "M150.973,7.3c0,.012-.533.5-.533.5.091-.024,1.293-.233,1.281-.233s-.735-.252-.748-.269",
    transform: "translate(-87.293 5.217)",
    fill: "#f4c627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8342",
    "data-name": "Caminho 8342",
    d: "M138.428,7.485a9.889,9.889,0,0,1,2.866-.879,21.293,21.293,0,0,1,2.986-.144s.125,1.545.125,1.557a20.635,20.635,0,0,0-2.787.173,10.594,10.594,0,0,0-2.813.687Z",
    transform: "translate(-95.873 4.616)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8343",
    "data-name": "Caminho 8343",
    d: "M138.8,8.913l-.389-1.406a9.565,9.565,0,0,1,2.89-.915,20.217,20.217,0,0,1,2.789-.144h.2c.024.024.156,1.569.156,1.581l-.24.029a16.756,16.756,0,0,0-2.58.168,10.831,10.831,0,0,0-2.812.682Zm5.463-2.441-.173.024a19.2,19.2,0,0,0-2.789.144,9.342,9.342,0,0,0-2.854.879l.377,1.341a10.346,10.346,0,0,1,2.8-.677,16.845,16.845,0,0,1,2.58-.166h.209c-.024-.012-.149-1.545-.149-1.545",
    transform: "translate(-95.882 4.606)",
    fill: "#d30028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8344",
    "data-name": "Caminho 8344",
    d: "M138.861,8.961c-.012,0,.449,1.641.449,1.641a24.529,24.529,0,0,1,2.52-.492c.844-.113,1.752-.185,2.566-.238l-.144-1.6a16.964,16.964,0,0,0-2.746.067,14.753,14.753,0,0,0-2.645.627",
    transform: "translate(-95.564 5.887)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8345",
    "data-name": "Caminho 8345",
    d: "M139.295,10.629l-.012-.007a13.978,13.978,0,0,1-.43-1.67,14.406,14.406,0,0,1,2.662-.634,17.39,17.39,0,0,1,2.748-.065l.161,1.627c-.807.072-1.718.139-2.585.264a24.309,24.309,0,0,0-2.52.485Zm3.885-2.364a12.762,12.762,0,0,0-1.653.1,13.964,13.964,0,0,0-2.645.622c.012.036.271.963.444,1.6a23.4,23.4,0,0,1,2.513-.483c.855-.127,1.778-.192,2.568-.24l-.168-1.586c-.324,0-.689-.012-1.059-.012",
    transform: "translate(-95.572 5.877)",
    fill: "#d30028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8346",
    "data-name": "Caminho 8346",
    d: "M136.551,11.618h24.2V27.129c-.61,6.033-6.41,10.551-11.729,10.515-5.722.252-12.053-4.44-12.5-10.574Z",
    transform: "translate(-97.239 8.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8347",
    "data-name": "Caminho 8347",
    d: "M148.631,37.78c-5.385,0-11.705-4.387-12.171-10.675l.053-15.453,24.273-.084.091,15.595c-.634,6.249-6.715,10.6-11.753,10.6-.2,0-.36.012-.492.012m12.077-26.127-24.117.084.048,15.369c.466,6.355,7,10.723,12.417,10.485,5.04,0,11.018-4.286,11.652-10.438Z",
    transform: "translate(-97.278 8.264)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8348",
    "data-name": "Caminho 8348",
    d: "M136.862,11.932h23.177V26.8c-.586,5.787-6.151,10.114-11.239,10.078-5.487.245-11.556-4.248-12-10.125Z",
    transform: "translate(-97.034 8.523)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8349",
    "data-name": "Caminho 8349",
    d: "M148.419,37.006c-5.163,0-11.213-4.19-11.662-10.221l.041-14.818,23.273-.084.079,14.949c-.6,5.991-6.422,10.162-11.263,10.162-.192.005-.336.012-.468.012m11.563-25.039-23.088.084.029,14.734c.456,6.086,6.734,10.263,11.909,10.041,4.831,0,10.563-4.1,11.15-10Z",
    transform: "translate(-97.066 8.488)",
    fill: "#cb0028"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_532",
    "data-name": "Ret\\xE2ngulo 532",
    width: 4.608,
    height: 4.961,
    transform: "translate(44.489 20.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8350",
    "data-name": "Caminho 8350",
    d: "M147.645,20.666v4.9l2.6.012a11.535,11.535,0,0,0,1.92-4.908Z",
    transform: "translate(-89.289 14.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8351",
    "data-name": "Caminho 8351",
    d: "M150.263,25.607l-2.607-.012-.026-4.92,2.169-.022h2.374a10.883,10.883,0,0,1-1.9,4.942Zm-2.607-4.913.016,4.877,2.568-.012a11.18,11.18,0,0,0,1.91-4.884l-2.35.019Z",
    transform: "translate(-89.3 14.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8352",
    "data-name": "Caminho 8352",
    d: "M144.953,23.55v4.7a11.96,11.96,0,0,0,4.567-2.071l-.012-2.633Z",
    transform: "translate(-91.212 16.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8353",
    "data-name": "Caminho 8353",
    d: "M144.942,28.3V23.56l4.572-.024.036,2.657a12.061,12.061,0,0,1-4.577,2.1Zm4.55-4.74-4.532.031.014,4.654a12.141,12.141,0,0,0,4.541-2.064Z",
    transform: "translate(-91.22 16.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8354",
    "data-name": "Caminho 8354",
    d: "M139.574,23.55l.01,2.633a13.059,13.059,0,0,0,4.56,2.028l-.012-4.654Z",
    transform: "translate(-95.054 16.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8355",
    "data-name": "Caminho 8355",
    d: "M144.17,28.246l-.017-.005a13.116,13.116,0,0,1-4.572-2.035l-.019-2.652,4.579-.012Zm-.053-4.685-4.536.024.036,2.6a13.2,13.2,0,0,0,4.512,2.006Z",
    transform: "translate(-95.063 16.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8356",
    "data-name": "Caminho 8356",
    d: "M136.885,20.666a9.911,9.911,0,0,0,1.867,4.841l2.688.055v-4.9Z",
    transform: "translate(-96.975 14.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8357",
    "data-name": "Caminho 8357",
    d: "M141.472,25.6h-.022l-2.688-.06a9.789,9.789,0,0,1-1.891-4.86l4.579-.024Zm-.041-4.92-4.536.019a9.951,9.951,0,0,0,1.891,4.805l2.645.048Z",
    transform: "translate(-96.985 14.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_533",
    "data-name": "Ret\\xE2ngulo 533",
    width: 4.608,
    height: 4.956,
    transform: "translate(39.881 25.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_534",
    "data-name": "Ret\\xE2ngulo 534",
    width: 4.615,
    height: 4.956,
    transform: "translate(49.097 25.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_535",
    "data-name": "Ret\\xE2ngulo 535",
    width: 4.608,
    height: 4.956,
    transform: "translate(53.712 20.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_536",
    "data-name": "Ret\\xE2ngulo 536",
    width: 4.608,
    height: 4.956,
    transform: "translate(58.332 25.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_537",
    "data-name": "Ret\\xE2ngulo 537",
    width: 4.608,
    height: 4.956,
    transform: "translate(44.489 30.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_538",
    "data-name": "Ret\\xE2ngulo 538",
    width: 4.608,
    height: 4.956,
    transform: "translate(53.712 30.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_539",
    "data-name": "Ret\\xE2ngulo 539",
    width: 4.615,
    height: 4.961,
    transform: "translate(49.097 35.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8358",
    "data-name": "Caminho 8358",
    d: "M146.32,8.8c-.024.024-.053-.216-.065-.252-.019-.072-.055-.173-.091-.322a.9.9,0,0,1,.156.574",
    transform: "translate(-90.347 5.875)",
    fill: "#c2a21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8359",
    "data-name": "Caminho 8359",
    d: "M146.33,8.818c-.029,0-.041-.024-.065-.192l-.115-.394a.7.7,0,0,1,.2.569Z",
    transform: "translate(-90.357 5.88)",
    fill: "#c2a21f"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCro);
export default __webpack_public_path__ + "static/media/flag_CRO.18c96440b207f4d2086738cdedaf7944.svg";
export { ForwardRef as ReactComponent };